import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'ClassroomsListfilter'
})
export class FilterPipeClassrooms implements PipeTransform {
    transform(classrooms: any, term?: any): any {
        if (term === undefined) return classrooms;
        if (term === null) return classrooms;

        if (classrooms != null) {
            return classrooms.filter(function (classroom) {
                if (classroom.name != undefined)
                    if (classroom.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return classroom;
                if (classroom.created_at != undefined)
                    if (moment(new Date(classroom.created_at.toDate())).format("DD/MM/YYYY HH:mm:ss").toString().toLowerCase().includes(term.toLowerCase()))
                        return classroom;
            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-list/filter.pipe.ts